import { media } from './media';

export default media;
